<div class="container-modal">
  <ng-container #widgetContainer></ng-container>
</div>
